import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/clientLog',
  title: window.language['client.clientLog'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('../Org/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/ClientLog/index.js